import { Box, Grid, Typography } from "@mui/material";
import { useAppSelector } from "store/appHooks";
import { DownloadFile } from "utils/download.util";

const BookingDocumentsList = () => {
  const { rentalsReducer } = useAppSelector((state) => state);
  const { selectedBookingData }: any = rentalsReducer;
  const { booking_documents } = selectedBookingData;

  // Departure
  const departureFiles = booking_documents?.filter(
    (d: any) => d.booking_stage === 1
  );
  const departureImages = departureFiles?.filter(
    (d: any) => d.document_type === 2
  );

  const departureDoc = departureFiles?.filter(
    (d: any) => d.document_type === 1
  );

  // Return
  const returnFiles = booking_documents?.filter(
    (d: any) => d.booking_stage === 2
  );
  const returnImages = returnFiles?.filter((d: any) => d.document_type === 2);

  const returnDoc = returnFiles?.filter((d: any) => d.document_type === 1);

  if (!booking_documents.length) return <></>;
  return (
    <Box sx={{ mt: "15px" }}>
      <Grid container spacing={2}>
        {departureFiles.length > 0 && (
          <Grid item sm={12} xs={12} md={6} lg={6} xl={6}>
            <DepartureDocumentGrid
              images={departureImages}
              docs={departureDoc}
            />
          </Grid>
        )}
        {returnFiles.length > 0 && (
          <Grid item sm={12} xs={12} md={6} lg={6} xl={6}>
            <ReturnDocumentGrid images={returnImages} docs={returnDoc} />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default BookingDocumentsList;

const DepartureDocumentGrid = ({ images, docs }: any) => {
  return (
    <Box>
      <Typography
        sx={{
          color: "#323232",
          fontWeight: 600,
          fontSize: "18px",
          lineHeight: "31px",

          mb: "10px",
        }}
      >
        Departure form and Images
      </Typography>
      {[docs[0]].map((d: any) => (
        <Box
          sx={{
            border: "1px solid #E2E2E2",
            borderRadius: "10px",
            padding: "15px",

            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          onClick={() => {
            DownloadFile(d.preview_url, d.name);
          }}
        >
          <Box sx={{ display: "flex", gap: "15px", alignItems: "center" }}>
            <img
              src="/assets/img/icons/pdf_ic.svg"
              alt=""
              width="36"
              height="48"
            />
            <Typography
              sx={{
                color: "#383838",
                fontWeight: 500,
                lineHeight: "22px",
                fontSize: "15px",
              }}
            >
              {d.name}
            </Typography>
          </Box>
          <img src="/assets/img/icons/arrow_down_cr.svg" alt="" />
        </Box>
      ))}

      <Box sx={{ display: "flex", gap: "10px", flexWrap: "wrap", mt: "15px" }}>
        {images.map((img: any) => (
          <img
            src={img.preview_url}
            alt=""
            height="72"
            width="72"
            style={{ borderRadius: "8px" }}
          />
        ))}
      </Box>
    </Box>
  );
};

const ReturnDocumentGrid = ({ images, docs }: any) => {
  return (
    <Box>
      <Typography
        sx={{
          color: "#323232",
          fontWeight: 600,
          fontSize: "18px",
          lineHeight: "31px",

          mb: "10px",
        }}
      >
        Return form and Images
      </Typography>
      {[docs[0]].map((d: any) => (
        <Box
          sx={{
            border: "1px solid #E2E2E2",
            borderRadius: "10px",
            padding: "15px",

            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: "15px",
              alignItems: "center",
              width: "90%",
            }}
          >
            <img
              src="/assets/img/icons/pdf_ic.svg"
              alt=""
              width="36"
              height="48"
            />
            <Typography
              sx={{
                color: "#383838",
                fontWeight: 500,
                lineHeight: "22px",
                fontSize: "15px",

                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {d.name}
            </Typography>
          </Box>
          <img src="/assets/img/icons/arrow_down_cr.svg" alt="" />
        </Box>
      ))}

      <Box sx={{ display: "flex", gap: "10px", flexWrap: "wrap", mt: "15px" }}>
        {images.map((img: any) => (
          <img
            src={img.preview_url}
            alt=""
            height="72"
            width="72"
            style={{ borderRadius: "8px" }}
          />
        ))}
      </Box>
    </Box>
  );
};
